import { IProperty } from '../utils/types';
import Calendar from './Calendar';

export type Props = {
  property: IProperty;
  offset: number;
};

const MonthAvailability = ({ property, offset }: Props) => {
  return (
    <div>
      <Calendar property={property} offset={offset} />
    </div>
  );
};

export default MonthAvailability;
